import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Post from '../Pages/Post/Post';
import Dashboard from '../Pages/Home/Dashboard';
import Trips from '../Pages/Trips/Trips';
import TripDetail from '../Pages/Trips/TripDetail';
import Checkout from '../Pages/Trips/Checkout';
import PlaceForm from '../Pages/Places/InputPlace';
import PostInput from '../Pages/Post/PostInput';
import Shorts from '../Pages/Shorts/Shorts';
import Profile from '../Pages/Profile/Profile';
import Login from '../Pages/Auth/Login';
import PrivateRoute from '../Components/PrivateRoute';
import Signup from '../Pages/Auth/Signup';
import UnAuthorizedRoute from '../Components/UnAuthorizedRoute';
import AllPlaces from '../Pages/Places/AllPlaces';
import PlaceDetail from '../Pages/Places/PlaceDetail';
import CreateTrip from '../Pages/Trips/createTrip';
import PlaceRelatedPost from '../Pages/Places/PlaceRelatedPost';
import ChatList from '../Pages/Chat/ChatList';
import Chat from '../Pages/Chat/Chat';
import PaymentScreen from '../Pages/Payment/PaymentScreen';
import Followers from '../Pages/Profile/Followers';
import FollowersScreen from '../Pages/Profile/FollowersScreen';
import AllReviews from '../Pages/Places/AllReviews';
import MyReviews from '../Pages/Places/MyReviews';
import BookingInfo from '../Pages/Trips/BookingInfo';
import BookingDetails from '../Pages/Trips/TripTab/BookingDetails';
import EditProfile from '../Pages/Profile/EditProfile';
import HamburgerMenu from '../Pages/HamburgerMenu/HamburgerMenu';
import AccountPrivacy from '../Pages/AccountPrivacy/AccountPrivacy';
import ChangePassword from '../Pages/Auth/ChangePassword';
import ForgotPassword from '../Pages/Auth/ForgotPassword';
import ForgotPasswordOTP from '../Pages/Auth/ForgotPasswordOTP';
import ResetPassword from '../Pages/Auth/ResetPassword';
import VisitedPlaces from '../Pages/Places/VisitedPlaces';
import MyPlaces from '../Pages/Places/MyPlaces';
import FavoritePlaces from '../Pages/Places/FavoritePlaces';
import SavedPosts from '../Pages/Post/SavedPosts';
import Drafts from '../Pages/Post/Drafts';
import TripDrafts from '../Pages/Trips/TripDrafts';
import HelpCenter from '../Pages/HelpCenter/HelpCenter';
import PhoneVerification from '../Pages/PhoneVerification/PhoneVerification';
import PrivacyPolicy from '../Pages/Legal/PrivacyPolicy';
import PostDetailScreen from '../Pages/Profile/PostDetailScreen';
import IntroSliderPage from '../Pages/IntroSlider/IntroSliderPage';
import UserSearch from '../Pages/Profile/UserSearch';

const AppRoutes = () => {

  return (
    <Routes>
      {/* IntroSlider route */}
      <Route path="/intro" element={<IntroSliderPage />} />
      {/* UnAuthorized routes */}
      <Route path="/" element={<Dashboard />} />
      <Route path="/shorts" element={<Shorts />} />
      <Route path="/shorts/:id" element={<Shorts />} />
      <Route path="/post" element={<Post />} />
      <Route path="/post/:postId" element={<Post />} />
      <Route path="/allplaces" element={<AllPlaces />} />
      <Route path="/my-places" element={<PrivateRoute><MyPlaces /></PrivateRoute>} />
      <Route path="/places/:id" element={<PlaceDetail />} />
      <Route path="/places/:id/posts" element={<PlaceRelatedPost placeId={''} type="" />} />
      {/* UnAuthorized routes */}
      <Route path="/login" element={<UnAuthorizedRoute><Login /></UnAuthorizedRoute>} />
      <Route path="/signup" element={<UnAuthorizedRoute><Signup /></UnAuthorizedRoute>} />
      <Route path="/forgot-password" element={<UnAuthorizedRoute><ForgotPassword /></UnAuthorizedRoute>} />
      <Route path="/forgot-password/otp" element={<UnAuthorizedRoute><ForgotPasswordOTP /></UnAuthorizedRoute>} />
      <Route path="/reset-password" element={<UnAuthorizedRoute><ResetPassword /></UnAuthorizedRoute>} />
      {/* Protected routes */}
      {/* Profile route with dynamic user id */}
      <Route path="/profile/:id" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/places/:id/reviews" element={<PrivateRoute><AllReviews /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/profile/edit" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
      <Route path="/profile/:id/followers" element={<PrivateRoute><Followers /></PrivateRoute>} />
      <Route path="/profile/:id/following" element={<PrivateRoute><Followers /></PrivateRoute>} />
      <Route path="/profile/:id/followers-screen" element={<PrivateRoute><FollowersScreen /></PrivateRoute>} />
      <Route path="/trips" element={<Trips />} />
      <Route path="/trips/:id" element={<PrivateRoute><TripDetail /></PrivateRoute>} />
      <Route path="/trips/:id/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
      <Route path="/trip/bookinginfo" element={<PrivateRoute><BookingInfo /></PrivateRoute>} />
      <Route path="/trips/:id/bookings" element={<PrivateRoute><BookingDetails /></PrivateRoute>} />
      <Route path="/createplace" element={<PrivateRoute><PlaceForm /></PrivateRoute>} />
      <Route path="/createpost" element={<PrivateRoute><PostInput /></PrivateRoute>} />
      <Route path="/post/input" element={<PrivateRoute><PostInput /></PrivateRoute>} />
      <Route path="/post/drafts" element={<PrivateRoute><Drafts /></PrivateRoute>} />
      <Route path="/place/drafts" element={<PrivateRoute><Drafts /></PrivateRoute>} />
      <Route path="/saved-posts" element={<PrivateRoute><SavedPosts /></PrivateRoute>} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/createtrip" element={<PrivateRoute><CreateTrip /></PrivateRoute>} />
      <Route path="/trip/drafts" element={<PrivateRoute><TripDrafts /></PrivateRoute>} />
      <Route path="/chatlist" element={<PrivateRoute><ChatList /></PrivateRoute>} />
      <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
      <Route path="/chat/:chatId" element={<PrivateRoute><Chat /></PrivateRoute>} />
      <Route path="/chat/chatlist" element={<PrivateRoute><ChatList /></PrivateRoute>} />
      <Route path="/payment" element={<PrivateRoute><PaymentScreen /></PrivateRoute>} />
      <Route path="/hamburger-menu" element={<PrivateRoute><HamburgerMenu /></PrivateRoute>} />
      <Route path="/help-center" element={<PrivateRoute><HelpCenter /></PrivateRoute>} />
      <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
      <Route path="/account-privacy" element={<PrivateRoute><AccountPrivacy /></PrivateRoute>} />
      <Route path="/profile/visited-places" element={<PrivateRoute><VisitedPlaces /></PrivateRoute>} />
      <Route path="/favorite-places" element={<PrivateRoute><FavoritePlaces /></PrivateRoute>} />
      <Route path="/my-reviews" element={<PrivateRoute><MyReviews /></PrivateRoute>} />
      <Route path="/profile/post-detail" element={<PrivateRoute><PostDetailScreen /></PrivateRoute>} />
      <Route path="/phone-verification" element={<PrivateRoute><PhoneVerification /></PrivateRoute>} />
      <Route path="/user-search" element={<PrivateRoute><UserSearch /></PrivateRoute>} />
      {/* Redirect unknown routes to home */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
